import { Wifi, WifiOff, Loader2 } from "lucide-react";
import type { ConnectionState } from "@/lib/socket";

interface ConnectionIndicatorProps {
  state: ConnectionState;
}

export default function ConnectionIndicator({ state }: ConnectionIndicatorProps) {
  if (state === "connected") {
    return (
      <div className="flex items-center gap-1.5 text-xs text-emerald-600">
        <Wifi className="h-3 w-3" />
        <span className="hidden sm:inline">Live</span>
      </div>
    );
  }

  if (state === "connecting") {
    return (
      <div className="flex items-center gap-1.5 text-xs text-amber-600">
        <Loader2 className="h-3 w-3 animate-spin" />
        <span className="hidden sm:inline">Reconnecting</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <WifiOff className="h-3 w-3" />
      <span className="hidden sm:inline">Offline</span>
    </div>
  );
}
